import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Paper,
  Typography,
  Chip,
  InputAdornment,
  Divider,
  Grid,
} from "@mui/material";
import CommonButton from "../../../../../components/common/CommonButton/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import CorporateFareIcon from "@mui/icons-material/CorporateFare"; // For the small icon next to title
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import { updateField } from "../../../../../features/editCompany/editCompanySlice";
//import dayjs, { Dayjs } from "dayjs";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';


// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from '@mui/x-date-pickers-pro';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const RequestSettings = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const draft = useSelector((state) => state.editCompany.draft);

  // Common styles for the TextFields to match the "pill" look in the image
  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      backgroundColor: "#fff",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.9rem",
      fontWeight: 500,
      color: "#666",
      marginBottom: "4px",
      position: "relative",
      transform: "none",
    },
    "& label": { position: "relative" },
    "& legend": { display: "none" },
    "& .MuiInputBase-input": { paddingTop: "10px" },
  };

//   const jakeSelect = {
//     height: 45,
//     div: {
//         borderRadius: "50px",
//         ".css-1l0bvs8-MuiPickersSectionList-root-MuiPickersInputBase-sectionsContainer-MuiPickersOutlinedInput-sectionsContainer": {
//             padding: "0px",            
//         }
//     }
//   }

  const periodObject = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Annual", value: "annual" },
  { label: "Custom", value: "custom" },
];

const monthOptions = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

const quarterOptions = [
  { value: "q1", label: "Q1 (Jan - Mar)" },
  { value: "q2", label: "Q2 (Apr - Jun)" },
  { value: "q3", label: "Q3 (Jul - Sep)" },
  { value: "q4", label: "Q4 (Oct - Dec)" },
];

const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [
    { value: currentYear - 4, label: `${currentYear - 4}` },
    { value: currentYear - 3, label: `${currentYear - 3}` },
    { value: currentYear - 2, label: `${currentYear - 2}` },
    { value: currentYear - 1, label: `${currentYear - 1}` },
    { value: currentYear, label: `${currentYear} (Current)` },
  ];
};

    const [activePeriod, setActivePeriod] = useState("monthly");
    const [textValue, setTextValue] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedQuarter, setSelectedQuarter] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [yearOptions, setYearOptions] = useState(getYearOptions());
    const [isPeriodVisible, setIsPeriodVisible] = useState(false);

  const filterButtonStyles = {
    width: "100%",
    textTransform: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    "&:hover": {
      boxShadow: "none",
    },
  };

  


  const handlePeriodChange = (periodValue, event) => {
    console.log("handlePeriodChange : ", periodValue);
    setActivePeriod(periodValue);
    setSelectedMonth("");
    setSelectedQuarter("");
    setSelectedYear("");
    setStartDate(null);
    setEndDate(null);
    setIsPeriodVisible(true);
  };

  const renderPeriodOptions = () => {
    switch (activePeriod) {
      case "monthly":
        return (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="month-select-label" >Select Month</InputLabel>
            <Select
              labelId="month-select-label"
              value={selectedMonth}
              //label="Select Month"
              onChange={(e) => setSelectedMonth(e.target.value)}
              size="small"
              sx={{
                borderRadius: 50
              }}
            >
              {monthOptions.map((month) => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "quarterly":
        return (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="quarter-select-label">Select Quarter</InputLabel>
            <Select
              labelId="quarter-select-label"
              value={selectedQuarter}
              //label="Select Quarter"
              onChange={(e) => setSelectedQuarter(e.target.value)}
              size="small"
              sx={{
                borderRadius: 50
              }}
            >
              {quarterOptions.map((quarter) => (
                <MenuItem key={quarter.value} value={quarter.value}>
                  {quarter.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "annual":
        return (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="year-select-label">Select Year</InputLabel>
            <Select
              labelId="year-select-label"
              value={selectedYear}
              //label="Select Year"
              onChange={(e) => setSelectedYear(e.target.value)}
              size="small"
              sx={{
                borderRadius: 50
              }}
            >
              {yearOptions.map((year) => (
                <MenuItem key={year.value} value={year.value}>
                  {year.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "custom":
        return (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary" }}>
              Select Date Range
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {/* <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      error: startDate && endDate && startDate > endDate,
                    },
                  }}
                /> */}
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  minDate={startDate}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      error: startDate && endDate && startDate > endDate,
                    },
                  }}
                /> */}
              </Grid>
              {startDate && endDate && startDate > endDate && (
                <Grid item xs={12}>
                  <Typography variant="caption" color="error">
                    End date must be after start date
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        );

      default:
        return null;
    }
  };

  const handleTextChange = (event) => {
    setTextValue(event.target.value);
  };
 
  const handleSubmit = (event) => {
    event.preventDefault();
    
    const formData = {
      textInput: textValue,
      periodType: activePeriod,
      selection: getSelectionValue(),
      dateRange: activePeriod === "custom" ? { startDate, endDate } : null,
    };
    
    console.log("Form submitted:", formData);
    // Handle form submission here
  };

  const getSelectionValue = () => {
    switch (activePeriod) {
      case "monthly":
        return selectedMonth;
      case "quarterly":
        return selectedQuarter;
      case "annual":
        return selectedYear;
      case "custom":
        return { startDate, endDate };
      default:
        return null;
    }
  };

  const isFormValid = () => {
    switch (activePeriod) {
      case "monthly":
        return textValue.trim() !== "" && selectedMonth !== "";
      case "quarterly":
        return textValue.trim() !== "" && selectedQuarter !== "";
      case "annual":
        return textValue.trim() !== "" && selectedYear !== "";
      case "custom":
        return (
          textValue.trim() !== "" &&
          startDate &&
          endDate &&
          startDate <= endDate
        );
      default:
        return textValue.trim() !== "";
    }
  };

  return (
        <Box 
            component="form"
            onSubmit={handleSubmit}
            sx={{ minHeight: "100vh", pb: 10, position: "relative" }}
        >
      {/* Main Card */}
      <Paper
        elevation={0}
        sx={{
          maxWidth: 800,
          mx: "auto",
          mt: 4,
          p: 4,
          borderRadius: "16px",
          border: "1px solid #e0e0e0",
          bgcolor: "#FAFAFA",
        }}
      >
        <Box display="flex" alignItems="center" gap={1} mb={3}>
          <SettingsIcon sx={{ fontSize: 18, color: "#888" }} />
          <Typography variant="subtitle2" fontWeight={700} color="#333">
            Settings
          </Typography>
        </Box>

        <Box display="flex" flexDirection="column" gap={2.5}>
          {/* Name */}
          <Box>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                mb: 0.5,
                color: "#666",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Add a report request name
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter a name"
              // value={draft.name}
              onChange={ handleTextChange }
              sx={fieldStyle}
            />
          </Box>
          {/* Period */}
          <Box>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                mb: 0.5,
                color: "#666",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Period
              <InfoIcon sx={{ fontSize: 15, color: "#888", ml: 0.5 }} />
            </Typography>
          </Box>

          <Grid container spacing={2}>
            {periodObject.map((option) => {
              const isActive = activePeriod === option.value;

              return (
                <Grid item xs={3} key={option.value}>
                  <CommonButton
                    autoFocus={option.label === "Monthly"} // Focus on "Monthly" initially
                    onClick={(e) => handlePeriodChange(option.value, e)}
                    variant="contained"
                    size="medium"
                    color={isActive ? "terciary" : "secondary"}
                    boxshadow={"none"}
                    sx={{
                      ...filterButtonStyles,
                      ...(isActive && {
                        fontWeight: "600",
                        color: "#005786",
                        span: {
                          color: "#005786",
                          marginLeft: "3px",
                        },
                      }),
                    }}
                  >
                    {option.label}
                    {/* Add quantity if needed */}
                    {/* <span>{option.qty}</span> */}
                  </CommonButton>
                </Grid>
              );
            })}
          </Grid>

            { isPeriodVisible && (
                <Grid spacing={1} sx={{ mt: 1 }}>
            
                    <Grid xs={6} md={6} lg={6} sx={{ width: '50%', position: 'relative', float: 'left' }}>
                        <Typography>
                            Select month
                        </Typography>
                        {renderPeriodOptions()}
                    </Grid>
                    <Grid xs={6} md={6} lg={6} sx={{ width: '48%', position: 'relative', float: 'left', marginLeft: 1, bottom: 8 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary" }}>
                                Due Date
                            </Typography>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker 
                                    label="Select Date" 
                                    value={endDate} 
                                    onChange={(newValue) => setEndDate(newValue)}
                                    // sx={jakeSelect}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </Grid>
                        
                </Grid>      
            )}
          

          {/* Submit Button */}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <CommonButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={!isFormValid()}
                sx={{
                minWidth: 120,
                textTransform: "none",
                backgroundColor: "#005786",
                "&:hover": {
                    backgroundColor: "#004a70",
                },
                }}
            >
                Submit
            </CommonButton>
            </Box>
        </Box>
      </Paper>

      {/* 🔷 Fixed Footer Actions */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: "#fff",
          borderTop: "1px solid #e0e0e0",
          p: 2,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate(`/company/${companyId}/edit/ownership`)}
          sx={{
            bgcolor: "#005682",
            textTransform: "none",
            borderRadius: "20px",
            px: 4,
            "&:hover": { bgcolor: "#004466" },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default RequestSettings;
